import axios from "axios";
const API_KEY = "55010344-80b9dd901c390fd896df977ab";
const BASE_URL = "https://pixabay.com/api/";
export async function getImagesByQuery(query) {
    try {
        const response = await axios.get(BASE_URL, {
            params: {
                key: API_KEY,
                q: query,
                image_type: "photo",
                orientation: "horizontal",
                safesearch: true,
            },
        });
        return response.data;
    } catch (error){
       throw error;
}     
    }
    
